export { default } from "./ListHistorialVentasSemana";
